import React from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button
} from 'reactstrap'
import { Link } from 'react-router-dom';
import { PropTypes } from "prop-types"
import Http from '../Http'
import { Line, Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { FormatNumberInEur, CalcDeltaChart } from './Utils'
import ChartDetails from './ChartDetails'


class ClientDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      showChartDetails: false,
      chartDetailsTitle: '',
      chartDetailsDescription: '',
      chartDetailsChartData: null,
      chartDetailsChartOptions: null,
      clientData: [],
      chartFatturatoData: {
        datasets: [],
        labels: [],
      },
      chartDeltaOptions: {
        tooltips: {
          mode: 'nearest',
          callbacks: {
            label: function (tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ": " + FormatNumberInEur(data.datasets[tooltipItem.datasetIndex].dataValues[tooltipItem.index], false);
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              fontColor: "#fff",
              callback: function (value, index, values) {
                return value > 0 ? "+" + value + "%" : value + "%"
              },
              maxTicksLimit: 5,
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }],
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return value > 0 ? "+" + value + "%" : value + "%"
            },
            color: '#fff'
          }
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartIncidAziendaSuClienteOptions: {
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: '#fff'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 5,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartAcquistiClienteData: {
        datasets: [],
        labels: [],
      },
      chartIncidAziendaSuClienteData: {
        datasets: [],
        labels: [],
      },
      chartCPFData: {
        datasets: [],
        labels: [],
      },
      chartCPFOptions: {
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: '#fff'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 5,
              min: -0.1,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartEXPData: {
        datasets: [],
        labels: [],
      },
      chartEXPOptions: {
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: '#fff'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 5,
              min: 0,
              max: 90,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
      },
      chartBoostOptions: {
        plugins: {

          datalabels: {
            formatter: function (value, context) {
              return ""
            },
            color: '#fff'
          }
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                maxTicksLimit: 5,
                min: 0,
                max: 100,
                beginAtZero: true,
                fontColor: "#fff"
              },
              stacked: true,
            },
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontColor: "#fff"
              }
            },
          ],
        },
      },
      chartNrDipendentiOptions: {
        plugins: {

          datalabels: {
            formatter: function (value, context) {
              return ""
            },
            color: '#fff'
          }
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                fontColor: "#fff"

              }
            },
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontColor: "#fff"

              }
            },
          ],
        },
      },
      chartMOLData: {
        datasets: [],
        labels: [],
      },
      chartInvestimentiData: {
        datasets: [],
        labels: [],
      },
      chartDeltaCostoPersonaleData: {
        datasets: [],
        labels: [],
      },
      chartCostoPersonaleSuRicaviData: {
        datasets: [],
        labels: [],
      },
      chartBoostData: {
        datasets: [],
        labels: [],
      },
      chartNrDipendentiData: {
        datasets: [],
        labels: [],
      },
    }

    this.toggleChartDetails = this.toggleChartDetails.bind(this)

    this.api = '/api/v1';
    //QCLIENT: env aggiungere api link
  }

  loadChartsData() {
    let datasetsChartFatturatoData = [], labelsChartFatturatoData = [];
    let datasetsChartAcquistiClienteData = [], labelsChartAcquistiClienteData = [];
    let datasetsChartIncidAziendaSuClienteData = [], labelsChartIncidAziendaSuClienteData = [];
    let datasetsChartCPF = [], labelsChartCPF = [];
    let datasetsChartEXP = [], labelsChartEXP = [];
    let datasetsChartMOLData = [], labelsChartMOLData = [];
    let datasetsChartInvestimentiData = [], labelsChartInvestimentiData = [];
    let datasetsChartDeltaCostoPersonaleData = [], labelsChartDeltaCostoPersonaleData = [];
    let datasetsChartCostoPersonaleSuRicaviData = [], labelsChartCostoPersonaleSuRicaviData = [];
    let datasetsChartBoost = [], labelsChartBoost = [], BoostEXP = [], BoostMercato = [], BoostOpportunita = [], BoostSegnalazione = []
    let datasetsChartNrDipendenti = [], labelsChartNrDipendentiData = []

    //dataset for fatturato: delta and fatturato cliente and bilancio
    datasetsChartFatturatoData.push(
      {
        label: 'Fatturato ' + this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartFatturatoBilancioData][0],
        data: [this.state.clientData.chartDeltaFatturatoBilancioData][0]
      })
    labelsChartFatturatoData = this.state.clientData.chartDeltaFatturatoClienteLabels

    datasetsChartAcquistiClienteData.push(
      {
        label: "Acquisti " + this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartAcquistiClienteData][0],
        data: [this.state.clientData.chartDeltaAcquistiClienteData][0]
      })
    labelsChartAcquistiClienteData = this.state.clientData.chartAcquistiClienteLabels

    datasetsChartIncidAziendaSuClienteData.push(
      {
        label: this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        data: [this.state.clientData.chartIncidAziendaSuClienteData][0]
      })
    labelsChartIncidAziendaSuClienteData = this.state.clientData.chartIncidAziendaSuClienteLabels

    datasetsChartCPF.push(
      {
        label: this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        data: [this.state.clientData.chartCPFData][0]
      })
    labelsChartCPF = this.state.clientData.chartCPFLabels

    datasetsChartEXP.push(
      {
        label: this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        data: [this.state.clientData.chartEXPData][0]
      })
    labelsChartEXP = this.state.clientData.chartEXPLabels

    datasetsChartMOLData.push(
      {
        label: "MOL " + this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartMOLData][0],
        data: [this.state.clientData.chartDeltaMOLData][0]
      })
    labelsChartMOLData = this.state.clientData.chartMOLLabels

    datasetsChartInvestimentiData.push(
      {
        label: this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartInvestimentiData][0],
        data: [this.state.clientData.chartDeltaInvestimentiData][0]
      })
    labelsChartInvestimentiData = this.state.clientData.chartInvestimentiLabels

    datasetsChartDeltaCostoPersonaleData.push(
      {
        label: this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartDeltaCostoPersonaleData][0],
        data: [this.state.clientData.chartDeltaCostoPersonaleData][0]
      })
    labelsChartDeltaCostoPersonaleData = this.state.clientData.chartDeltaCostoPersonaleLabels

    datasetsChartCostoPersonaleSuRicaviData.push(
      {
        label: this.state.clientData.name,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartCostoPersonaleSuRicaviData][0],
        data: [this.state.clientData.chartCostoPersonaleSuRicaviData][0]
      })
    labelsChartCostoPersonaleSuRicaviData = this.state.clientData.chartCostoPersonaleSuRicaviLabels

    if (this.state.clientData.chartBoostData.length > 0) {
      BoostEXP.push(this.state.clientData.chartBoostData[0])
      BoostMercato.push(this.state.clientData.chartBoostData[1])
      BoostOpportunita.push(this.state.clientData.chartBoostData[2])
      BoostSegnalazione.push(this.state.clientData.chartBoostData[3])
      let sum = FormatNumberInEur(parseFloat(this.state.clientData.chartBoostData[0]) + parseFloat(this.state.clientData.chartBoostData[1]) + parseFloat(this.state.clientData.chartBoostData[2]) + parseFloat(this.state.clientData.chartBoostData[3]), false, true)
      labelsChartBoost.push(this.state.clientData.name)
      datasetsChartBoost.push(
        {
          label: "EXP",
          backgroundColor: 'rgba(227,38,54, 0.8)',
          data: BoostEXP
        })
      datasetsChartBoost.push(
        {
          label: "Mercato",
          backgroundColor: 'rgba(0,181,199, 0.8)',
          data: BoostMercato
        })
      datasetsChartBoost.push(
        {
          label: "Opportunita",
          backgroundColor: 'rgba(31,117,254, 0.8)',
          data: BoostOpportunita
        })
      datasetsChartBoost.push(
        {
          label: "Segnalazione",
          backgroundColor: 'rgba(169,169,169, 0.8)',
          data: BoostSegnalazione,
          datalabels: {
            labels: {
              value: {
                align: 'top',
                borderColor: 'white',
                backgroundColor: 'white',
                color: 'gray',
                font: {
                  weight: 'bold'
                },
                borderWidth: 1,
                borderRadius: 4,
                formatter: function (value, ctx) {
                  return sum;
                },
                padding: 4
              }
            }
          }
        })
    }

    datasetsChartNrDipendenti.push(
      {
        label: "Numero Dipendenti",
        backgroundColor: 'rgba(0,228,186, 0.8)',
        data: [this.state.clientData.chartNrDipendentiData][0],
        datalabels: {
          labels: {
            value: {
              align: 'top',
              borderColor: 'white',
              backgroundColor: 'white',
              color: 'gray',
              font: {
                weight: 'bold'
              },
              borderWidth: 1,
              borderRadius: 4,
              formatter: function (value, ctx) {
                return value;
              },
              padding: 4
            }
          }
        }
      })
    labelsChartNrDipendentiData = this.state.clientData.chartNrDipendentiLabels

    let { chartFatturatoData, chartAcquistiClienteData, chartIncidAziendaSuClienteData, chartCPFData, chartEXPData, chartBoostData, chartMOLData, chartInvestimentiData, chartDeltaCostoPersonaleData, chartCostoPersonaleSuRicaviData, chartNrDipendentiData } = this.state
    chartFatturatoData.datasets = datasetsChartFatturatoData
    chartFatturatoData.labels = labelsChartFatturatoData
    chartAcquistiClienteData.datasets = datasetsChartAcquistiClienteData
    chartAcquistiClienteData.labels = labelsChartAcquistiClienteData
    chartIncidAziendaSuClienteData.datasets = datasetsChartIncidAziendaSuClienteData
    chartIncidAziendaSuClienteData.labels = labelsChartIncidAziendaSuClienteData
    chartCPFData.datasets = datasetsChartCPF
    chartCPFData.labels = labelsChartCPF
    chartEXPData.datasets = datasetsChartEXP
    chartEXPData.labels = labelsChartEXP
    chartMOLData.datasets = datasetsChartMOLData
    chartMOLData.labels = labelsChartMOLData
    chartInvestimentiData.datasets = datasetsChartInvestimentiData
    chartInvestimentiData.labels = labelsChartInvestimentiData
    chartDeltaCostoPersonaleData.datasets = datasetsChartDeltaCostoPersonaleData
    chartDeltaCostoPersonaleData.labels = labelsChartDeltaCostoPersonaleData
    chartCostoPersonaleSuRicaviData.datasets = datasetsChartCostoPersonaleSuRicaviData
    chartCostoPersonaleSuRicaviData.labels = labelsChartCostoPersonaleSuRicaviData
    chartBoostData.datasets = datasetsChartBoost
    chartBoostData.labels = labelsChartBoost
    chartNrDipendentiData.datasets = datasetsChartNrDipendenti
    chartNrDipendentiData.labels = labelsChartNrDipendentiData

    this.setState({
      chartFatturatoData,
      chartNrDipendentiData,
      chartCostoPersonaleSuRicaviData,
      chartDeltaCostoPersonaleData,
      chartMOLData,
      chartInvestimentiData,
      chartAcquistiClienteData,
      chartIncidAziendaSuClienteData,
      chartCPFData,
      chartEXPData,
      chartBoostData,
      loading: false
    })
  }


  componentDidMount() {
    //margin bottom under legend
    // Chart.plugins.register({
    //     beforeInit: function (chart, options) {
    //         chart.legend.afterFit = function () {
    //             this.height = this.height;
    //         };
    //     }
    // });
    Chart.plugins.register(ChartDataLabels);

    Http.get(`${this.api}/client/${this.props.clientId}`)
      .then((response) => {
        const { data } = response.data;
        if (data == []) {
          // alert('Si è verificato un errore: cliente non valido')
          this.setState({
            error: 'Si è verificato un errore: cliente non valido',
            loading: false
          });
        }
        this.setState({
          clientData: data,
        });
        this.loadChartsData()
      })

  }

  toggleChartDetails(chartName) {
    let { showChartDetails } = this.state
    if (showChartDetails) {
      this.setState({
        showChartDetails: false
      })
    }
    let { chartDeltaOptions, chartIncidAziendaSuClienteOptions } = this.state
    switch (chartName) {
      case 'fatturato':
        let { chartFatturatoData } = this.state
        chartDeltaOptions.indexName = "fatturato_bilancio"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'Fatturato',
          chartDetailsDescription: 'Evoluzione fatturato negli anni',
          chartDetailsChartData: chartFatturatoData,
          chartDetailsChartOptions: chartDeltaOptions
        })
        break;
      case 'acquisti':
        let { chartAcquistiClienteData } = this.state
        chartDeltaOptions.indexName = "costo_del_venduto"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'Acquisti',
          chartDetailsDescription: 'Evoluzione degli Acquisti negli anni',
          chartDetailsChartData: chartAcquistiClienteData,
          chartDetailsChartOptions: chartDeltaOptions,
        })
        break;
      case 'incidenza':
        let { chartIncidAziendaSuClienteData } = this.state
        chartIncidAziendaSuClienteOptions.indexName = "incid_az_su_cliente"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'Incidenza',
          chartDetailsDescription: 'Evoluzione Incidenza negli anni',
          chartDetailsChartData: chartIncidAziendaSuClienteData,
          chartDetailsChartOptions: chartIncidAziendaSuClienteOptions,
        })
        break;
      case 'mol':
        let { chartMOLData } = this.state
        chartDeltaOptions.indexName = "mol"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'MOL',
          chartDetailsDescription: 'Evoluzione MOL negli anni',
          chartDetailsChartData: chartMOLData,
          chartDetailsChartOptions: chartDeltaOptions,
        })
        break;
      case 'investimenti':
        let { chartInvestimentiData } = this.state
        chartDeltaOptions.indexName = "evo_invest_fissi_lordi"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'Investimenti',
          chartDetailsDescription: 'Evoluzione Investimenti fissi lordi negli anni',
          chartDetailsChartData: chartInvestimentiData,
          chartDetailsChartOptions: chartDeltaOptions,
        })
        break;
      case 'costo_personale':
        let { chartDeltaCostoPersonaleData } = this.state
        chartDeltaOptions.indexName = "delta_perc_cost_pers_ap"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'Costo del Personale',
          chartDetailsDescription: 'Evoluzione Costo del Personale negli anni',
          chartDetailsChartData: chartDeltaCostoPersonaleData,
          chartDetailsChartOptions: chartDeltaOptions,
        })
        break;
      case 'costo_personale_su_ricavi':
        let { chartCostoPersonaleSuRicaviData } = this.state
        chartIncidAziendaSuClienteOptions.indexName = "costo_personale_su_ricavi"
        this.setState({
          showChartDetails: true,
          chartDetailsTitle: 'Costo del Personale su Fatturato',
          chartDetailsDescription: 'Evoluzione Costo del Personale su Fatturato negli anni',
          chartDetailsChartData: chartCostoPersonaleSuRicaviData,
          chartDetailsChartOptions: chartIncidAziendaSuClienteOptions,
        })
        break;
      default:
        break;
    }
  }

  render() {
    let fatturatoChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Fatturato</h3>
          </Col>
          <Col md="4">
            <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('fatturato')}>Dettaglio</Button>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartFatturatoData}
          options={this.state.chartDeltaOptions} />
      </CardBody>
    </Card>)

    let acquistiChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Acquisti (costo del venduto)</h3>
          </Col>
          <Col md="4">
            <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('acquisti')}>Dettaglio</Button>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartAcquistiClienteData}
          options={this.state.chartDeltaOptions} />
      </CardBody>
    </Card>)

    let molChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">MOL</h3>
          </Col>
          <Col md="4">
            <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('mol')}>Dettaglio</Button>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartMOLData}
          options={this.state.chartDeltaOptions} />
      </CardBody>
    </Card>)

    let incidenzaAziendaSuClientChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Incidenza Azienda su cliente</h3>
          </Col>
          <Col md="4">
            <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('incidenza')}>Dettaglio</Button>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartIncidAziendaSuClienteData}
          options={this.state.chartIncidAziendaSuClienteOptions} />
      </CardBody>
    </Card>)

    let investimentiFissiLordiChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Investimenti fissi lordi</h3>
          </Col>
          <Col md="4">
            <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('investimenti')}>Dettaglio</Button>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartInvestimentiData}
          options={this.state.chartDeltaOptions} />
      </CardBody>
    </Card>)

    let deltaCostoPersonaleChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Costo del Personale</h3>
          </Col>
          <Col md="4">
            <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('costo_personale')}>Dettaglio</Button>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartDeltaCostoPersonaleData}
          options={this.state.chartDeltaOptions} />
      </CardBody>
    </Card>)

    let cpfChart = (<Card>
      <CardBody>
        <Row>
          <Col md="12" className="mb-3">
            <h3 className="text-left mb-0">Coefficiente Potenza di Fuoco</h3>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartCPFData}
          options={this.state.chartCPFOptions} />
      </CardBody>
    </Card>)

    let expChart = (<Card>
      <CardBody>
        <Row>
          <Col md="12" className="mb-3">
            <h3 className="text-left mb-0">EXP</h3>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartEXPData}
          options={this.state.chartEXPOptions} />
      </CardBody>
    </Card>)

    let boostChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Boost</h3>
            <p className="text-left">Coefficiente di Propulsione</p>
          </Col>
        </Row>
        <Row>
          <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(169,169,169, 0.8)" }}></p><p className="client-legend-name">Segnalazione</p></div>
          <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(31,117,254, 0.8)" }}></p><p className="client-legend-name">Opportunita</p></div>
          <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(0,181,199, 0.8)" }}></p><p className="client-legend-name">Mercato</p></div>
          <div className="client-legend-col col-md-3"><p className="client-legend" style={{ backgroundColor: "rgba(227,38,54, 0.8)" }}></p><p className="client-legend-name">EXP</p></div>
        </Row>
        <Bar data={this.state.chartBoostData} height={150} width={null} options={this.state.chartBoostOptions} />
      </CardBody>
    </Card>)

    let costoPersonaleSuRicaviChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Costo del Personale su Fatturato</h3>
          </Col>
          <Col md="4">
            <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => this.toggleChartDetails('costo_personale_su_ricavi')}>Dettaglio</Button>
          </Col>
        </Row>
        <Line height={150} width={null}
          data={this.state.chartCostoPersonaleSuRicaviData}
          options={this.state.chartIncidAziendaSuClienteOptions} />
      </CardBody>
    </Card>)

    let nrDipendentiChart = (<Card>
      <CardBody>
        <Row>
          <Col md="8" className="mb-3">
            <h3 className="text-left mb-0">Numero Dipendenti</h3>
          </Col>
        </Row>
        <Bar data={this.state.chartNrDipendentiData} height={150} width={null} options={this.state.chartNrDipendentiOptions} />
      </CardBody>
    </Card>)

    if (this.state.loading) {
      return (
        <div className="content text-center">
          <Spinner style={{ width: '3rem', height: '3rem' }} type="grow" />
        </div>
      )
    } else {
      if (this.state.showChartDetails) {
        return (
          <ChartDetails
            user={this.props.user}
            title={this.state.chartDetailsTitle}
            description={this.state.chartDetailsDescription}
            chartData={this.state.chartDetailsChartData}
            chartOptions={this.state.chartDetailsChartOptions}
            toggleChartDetails={this.toggleChartDetails}
            clientsData={[this.state.clientData]}
          />
        )
      } else {
        return (<Row>
          <Col md="12">
            <Card>
              <h3 className="text-left m-3">STATISTICHE {this.state.clientData.name}</h3>
            </Card>
          </Col>
          <Col md="6" >
            {fatturatoChart}
          </Col>
          <Col md="6" >
            {acquistiChart}
          </Col>
          <Col md="6" >
            {molChart}
          </Col>
          <Col md="6" >
            {expChart}
          </Col>
          {(this.props.user.roles.indexOf('qclient-evolution') > -1 || this.props.user.roles.indexOf('superadmin') > -1) ?
            (<Col md="12" >
              <Card>
                <Row>
                  <Col>
                  </Col>
                  <Col>
                    <Link to={'/evolution/' + this.props.clientId} alt="Stime cliente">
                      <Button className="animation-on-hover float-right m-3 text-center" color="primary" >Evolution</Button>
                    </Link>
                  </Col>
                </Row>
              </Card>
            </Col>) : (null)}
        </Row>)
      }
    }
  }
}

ClientDetails.propTypes = {
  clientId: PropTypes.number.isRequired,
};

export default ClientDetails;
